export default __webpack_public_path__ + "static/assets/8c13f742b18587c21420df397ed15cfd.png";